module.exports = __webpack_public_path__ + "img/03.a2504431.jpg";